var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59998C12.6627 3.59998 13.2 4.13723 13.2 4.79998V10.8H19.2C19.8627 10.8 20.4 11.3372 20.4 12C20.4 12.6627 19.8627 13.2 19.2 13.2H13.2V19.2C13.2 19.8627 12.6627 20.4 12 20.4C11.3372 20.4 10.8 19.8627 10.8 19.2V13.2H4.79998C4.13723 13.2 3.59998 12.6627 3.59998 12C3.59998 11.3372 4.13723 10.8 4.79998 10.8L10.8 10.8V4.79998C10.8 4.13723 11.3372 3.59998 12 3.59998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.4aa4a6a607c950cd5a0b7dba89c5a828.svg";
export { ForwardRef as ReactComponent };